export { ClientsModule } from './clients.module';
export { ClientsService } from './clients.service';
export { orderClientsByGroupName } from './client.helpers';
export * from './client.types';
